// @ts-nocheck
import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import Search from "@store/Library/Components/Toolkit/Icons/Search";
import { filtersProps } from "@store/Themes/common/props/filters";
import { formGetAltTextFieldProps } from "@store/Themes/common/props/form";

Object.assign(searchWithinStyles, {
    wrapper: filtersProps.section,
    titleText: filtersProps.title,
    searchTextField: formGetAltTextFieldProps(Search),
});
